const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.experience-card {
  position: relative;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
}

.experience-card-dark {
  position: relative;
  background-color: #171c28;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
}

.experience-card:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;
}

.experience-banner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 150%;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5));
  border-radius: 10px 10px 0px 0px;
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(0px);
  filter: blur(0px);
  height: 11rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.experience-blurred_div {
  position: absolute;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2));
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  height: 11rem;
  top: 0;
  left: 0;
  width: 100%;
  border-radius: 10px 10px 0px 0px;
}

.experience-div-company {
  position: absolute;
  background: transparent;
  height: 9rem;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.experience-text-company {
  text-align: center;
  padding: 1.5rem;
  margin: 0;
  color: #fff;
  font-size: 25px;
  text-align: center;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.experience-roundedimg {
  position: absolute;
  object-fit: cover;
  left: 0;
  right: 0;
  top: 7rem;
  margin-left: auto;
  margin-right: auto;
  width: 8rem;
  height: 8rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}

.experience-text-role {
  text-align: center;
  color: #000000;
  font-weight: 700;
  font-size: 25px;
  margin: 0px;
  padding-top: 1.5rem;
  line-height: normal;
}

.dark-mode-text {
  color: #ffffff !important;
}

.experience-text-date {
  text-align: center;
  color: #000000;
  font-size: 20px;
  margin: 0px;
  padding-top: 1rem;
  font-weight: 600;
}

.experience-text-desc {
  text-align: center;
}

.experience-text-details {
  padding: 1.5rem;
  margin-top: 2rem;
}

/* Media Query */
@media (max-width: 1380px) {
  .experience-text-role {
    padding-top: 0.5rem;
    font-size: 22px;
  }
  .experience-text-company {
    font-size: 22px;
  }
  .experience-text-date {
    font-size: 18px;
  }
  .experience-roundedimg {
    width: 6.5rem;
    height: 6.5rem;
  }
}
@media (max-width: 768px) {
  .experience-text-role {
    font-size: 22px;
  }
  .experience-text-company {
    font-size: 22px;
  }
  .experience-text-date {
    font-size: 18px;
  }
  .experience-text-desc {
    font-size: 16px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL1VzZXJzL2RpeGl0cmphaW4vcHJvamVjdHMvZGV2cG9ydGZvbGlvL2FwcHMvcG9ydGZvbGlvLXVpL3NyYy9jb21wb25lbnRzL2V4cGVyaWVuY2VDYXJkIiwic291cmNlcyI6WyIuLi8uLi9fZ2xvYmFsQ29sb3Iuc2NzcyIsIkV4cGVyaWVuY2VDYXJkLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFBQTtBQUFBO0FDRUE7RUFDRTtFQUNBLGtCRDhCaUI7RUM3QmpCO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBLGtCRDBCZTtFQ3pCZjtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0EsWUQ0QnVCO0VDM0J2QjtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBLFlEUzJCO0VDUjNCO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQSxPRHJDaUI7RUNzQ2pCO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0EsT0RwRlU7RUNxRlY7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBLE9EaEdVO0VDaUdWO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0FBRUE7RUFDRTtJQUNFO0lBQ0E7O0VBRUY7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7SUFDQTs7O0FBSUo7RUFDRTtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7RUFFRjtJQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogQ2hhbmdlIGNvbG9ycyBpbiB0aGlzIGZpbGUgdG8gc3R5bGUgdG8geW91ciBuZWVkcyBvbiBhIGdsb2JhbCBsZXZlbC4gXG5DZXJ0YWluIGNvbG9ycyBhcmUgdXNlZCBmb3IgZGlmZmVyZW50IGFuZCBtdWx0aXBseSB0eXBlcyBvZiBlbGVtZW50cy4gXG5Gb3IgZ3JlYXRlciBjb250cm9sIG92ZXIgY29sb3JzIHZpc2l0IGVhY2ggY29tcG9uZW50cyAuc2NzcyBmaWxlLiAqL1xuXG4vLyBidXR0b24gY29sb3JzXG4kYnV0dG9uQ29sb3I6ICM1NTE5OGI7XG4kYnV0dG9uSG92ZXI6ICM4YzQzY2U7XG4kdG9wQnV0dG9uSG92ZXI6ICMwMDA7XG5cbi8vIHRleHQgY29sb3JzIGxpZ2h0IHRoZW1lXG4kdGl0bGVDb2xvcjogIzAwMDAwMDtcbiR0ZXh0Q29sb3I6ICMwMDAwMDA7XG4kc3ViVGl0bGU6ICM4NjhlOTY7XG4kY2FyZFN1YnRpdGxlOiAjNjY2NjY2O1xuJHRhbGtDYXJkU3ViVGl0bGU6ICM3ZjgyODc7XG4kYmxvZ0NhcmRUaXRsZUNvbG9yOiAjMjYyNjI2O1xuXG4vLyB0ZXh0IGNvbG9yIGRhcmsgdGhlbWVcbiR0ZXh0Q29sb3JEYXJrOiAjZmZmZmZmO1xuXG4vLyB0b2dnbGUgc3dpdGNoIGNvbG9yc1xuJHRvZ2dsZUNoZWNrOiAjMjE5NmYzO1xuJHRvZ2dsZVN3aXRjaFNsaWRlckJHOiAjY2NjO1xuXG4vLyBnaXRodWJSZXBvIHNwZWNpZmljIGNvbG9yc1xuJGdpdGh1YlJlcG9DYXJkTGFuZ3VhZ2VDb2xvckJHOiAjMDAwMGZmO1xuJGdpdGh1YlJlcG9DYXJkQ29sb3I6IHJnYig4OCwgOTYsIDEwNSk7XG4kZ2l0aHViUmVwb0NhcmRSZXBvQ2FyZFN0YXRzQ29sb3I6IHJnYigxMDYsIDExNSwgMTI1KTtcbiRnaXRodWJSZXBvQ2FyZFJlcG9OYW1lQ29sb3I6IHJnYigzNiwgNDEsIDQ2KTtcbiRnaXRodWJQcm9maWxlQ2FyZExvY2F0aW9uVFM6ICNmZmViY2Q7XG4kZ2l0aHViUHJvZmlsZUNhcmRCb3JkZXI6ICM2YzYzZmY7XG5cbi8vIGxpZ2h0IGJhY2tncm91bmQgY29sb3JzXG4kbGlnaHRCYWNrZ3JvdW5kMTogI2ZmZjtcbiRsaWdodEJhY2tncm91bmQyOiByZ2IoMjU1LCAyNTUsIDI1NSk7XG4kbGlnaHRCYWNrZ3JvdW5kMzogI2Y1ZjJmNDtcbiRibG9nQ2FyZENvbnRhaW5lckNvbG9yOiAjNTg2MDY5O1xuLy8gZGFyayBiYWNrZ3JvdW5kIGNvbG9yc1xuJGRhcmtCYWNrZ3JvdW5kOiAjMTcxYzI4O1xuXG4vLyBsaWdodCB0aGVtZSBib3ggc2hhZG93c1xuJGxpZ2h0Qm94U2hhZG93RGFyazogcmdiYSgwLCAwLCAwLCAwLjIpO1xuJGxpZ2h0Qm94U2hhZG93OiByZ2JhKDAsIDAsIDAsIDAuMSk7XG4kbGlnaHRCb3hTaGFkb3dEYXJrZXI6IHJnYmEoMCwgMCwgMCwgMC4zKTtcblxuLy8gZGFyayB0aGVtZSBib3ggc2hhZG93c1xuJGRhcmtCb3hTaGFkb3c6ICNkOWRiZGY7XG4kZGFya0JveFNoYWRvdzI6ICNmZmZmZmY7XG5cbi8vIGxpbmVhciBncmFkaWVudHNcbiRleHBlcmllbmNlQ2FyZEJsdXJyZWREaXZMRzogbGluZWFyLWdyYWRpZW50KFxuICByZ2JhKDAsIDAsIDAsIDAuNCksXG4gIHJnYmEoMCwgMCwgMCwgMC4yKVxuKTtcbiRleHBlcmllbmNlQ2FyZEJhbm5lckxHOiBsaW5lYXItZ3JhZGllbnQoXG4gIHJnYmEoMCwgMCwgMCwgMC43KSxcbiAgcmdiYSgwLCAwLCAwLCAwLjUpXG4pO1xuXG4vLyBib3JkZXJzXG4kcHJvZ3Jlc3NCYXJCYWNrZ3JvdW5kOiByZ2IoMjQzLCAyMzksIDIzOSk7XG4kbGlnaHRCb3JkZXIxOiByZ2JhKDIxMSwgMjExLCAyMTEsIDAuMzk3KTtcbiRlZHVjYXRpb25DYXJkQm9yZGVyOiAjYTlhN2Y5O1xuXG4vLyBob3ZlcnNcbiRhY2hpZXZlbWVudENlcnRpZmljYXRlQ2FyZEhvdmVyRGFyazogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjIpO1xuJGJsb2dDYXJkSG92ZXJTbWFsbENvbG9yOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuOCk7XG4kaGVhZGVySG92ZXJCRzogI2Y0ZjRmNDtcbiRjb250YWN0RGV0YWlsSG92ZXJUUzogI2I1YjViNTtcblxuLy8gbWlzYyBiYWNrZ3JvdW5kc1xuJHByb2dyZXNzQmFyU3BhbkJHOiAjYWFhNWZmO1xuJGljb25CYWNrZ3JvdW5kOiAjMzMzO1xuJGFwcEhlYWRlckJHOiAjMjgyYzM0O1xuXG4vLyBtaXNjIGNvbG9yc1xuJHNraWxsc0NvbG9yOiAjNjQ1YmViO1xuJGFwcExpbms6ICMwOWQzYWM7XG5cbi8vIHNvY2lhbCBtZWRpYSBpY29uc1xuJGZhY2VCb29rOiAjM2I1OTk4O1xuJGxpbmtlZGluOiAjMGU3NmE4O1xuJGdpdGh1YjogIzMzMztcbiRnb29nbGU6ICNlYTQzMzU7XG4kbWVkaXVtOiAjMDAwO1xuJGRldlRvOiAjMDAwO1xuJGluc3RhZ3JhbTogI2MxMzU4NDtcbiIsIkBpbXBvcnQgXCIuLi8uLi9fZ2xvYmFsQ29sb3JcIjtcblxuLmV4cGVyaWVuY2UtY2FyZCB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJGxpZ2h0QmFja2dyb3VuZDI7XG4gIGJveC1zaGFkb3c6ICRsaWdodEJveFNoYWRvd0RhcmsgMHB4IDEwcHggMzBweCAtMTVweDtcbiAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgYm9yZGVyOiAxcHggc29saWQgJGxpZ2h0Qm9yZGVyMTtcbn1cblxuLmV4cGVyaWVuY2UtY2FyZC1kYXJrIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkZGFya0JhY2tncm91bmQ7XG4gIGJveC1zaGFkb3c6ICRsaWdodEJveFNoYWRvd0RhcmsgMHB4IDEwcHggMzBweCAtMTVweDtcbiAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgYm9yZGVyOiAxcHggc29saWQgJGxpZ2h0Qm9yZGVyMTtcbn1cblxuLmV4cGVyaWVuY2UtY2FyZDpob3ZlciB7XG4gIGJveC1zaGFkb3c6ICRsaWdodEJveFNoYWRvd0RhcmsgMHB4IDIwcHggMzBweCAtMTBweDtcbn1cblxuLmV4cGVyaWVuY2UtYmFubmVyIHtcbiAgYmFja2dyb3VuZC1wb3NpdGlvbjogY2VudGVyO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBiYWNrZ3JvdW5kLXNpemU6IDE1MCU7XG4gIGJhY2tncm91bmQ6ICRleHBlcmllbmNlQ2FyZEJhbm5lckxHO1xuICBib3JkZXItcmFkaXVzOiAxMHB4IDEwcHggMHB4IDBweDtcbiAgLXdlYmtpdC1maWx0ZXI6IGJsdXIoMHB4KTtcbiAgLW1vei1maWx0ZXI6IGJsdXIoMHB4KTtcbiAgLW8tZmlsdGVyOiBibHVyKDBweCk7XG4gIC1tcy1maWx0ZXI6IGJsdXIoMHB4KTtcbiAgZmlsdGVyOiBibHVyKDBweCk7XG4gIGhlaWdodDogMTFyZW07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LWVuZDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG59XG5cbi5leHBlcmllbmNlLWJsdXJyZWRfZGl2IHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBiYWNrZ3JvdW5kOiAkZXhwZXJpZW5jZUNhcmRCbHVycmVkRGl2TEc7XG4gIC13ZWJraXQtZmlsdGVyOiBibHVyKDVweCk7XG4gIC1tb3otZmlsdGVyOiBibHVyKDVweCk7XG4gIC1vLWZpbHRlcjogYmx1cig1cHgpO1xuICAtbXMtZmlsdGVyOiBibHVyKDVweCk7XG4gIGZpbHRlcjogYmx1cig1cHgpO1xuICBoZWlnaHQ6IDExcmVtO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHdpZHRoOiAxMDAlO1xuICBib3JkZXItcmFkaXVzOiAxMHB4IDEwcHggMHB4IDBweDtcbn1cblxuLmV4cGVyaWVuY2UtZGl2LWNvbXBhbnkge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICBoZWlnaHQ6IDlyZW07XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuXG4uZXhwZXJpZW5jZS10ZXh0LWNvbXBhbnkge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDEuNXJlbTtcbiAgbWFyZ2luOiAwO1xuICBjb2xvcjogJGxpZ2h0QmFja2dyb3VuZDE7XG4gIGZvbnQtc2l6ZTogMjVweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBmb250LXdlaWdodDogNzAwO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbn1cblxuLmV4cGVyaWVuY2Utcm91bmRlZGltZyB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgb2JqZWN0LWZpdDogY292ZXI7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuICB0b3A6IDdyZW07XG4gIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICBtYXJnaW4tcmlnaHQ6IGF1dG87XG4gIHdpZHRoOiA4cmVtO1xuICBoZWlnaHQ6IDhyZW07XG4gIGJveC1zaGFkb3c6IDAgMC41cmVtIDFyZW0gJGxpZ2h0Qm94U2hhZG93RGFya2VyO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG59XG5cbi5leHBlcmllbmNlLXRleHQtcm9sZSB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgY29sb3I6ICR0ZXh0Q29sb3I7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGZvbnQtc2l6ZTogMjVweDtcbiAgbWFyZ2luOiAwcHg7XG4gIHBhZGRpbmctdG9wOiAxLjVyZW07XG4gIGxpbmUtaGVpZ2h0OiBub3JtYWw7XG59XG4uZGFyay1tb2RlLXRleHQge1xuICBjb2xvcjogJHRleHRDb2xvckRhcmsgIWltcG9ydGFudDtcbn1cbi5leHBlcmllbmNlLXRleHQtZGF0ZSB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgY29sb3I6ICR0ZXh0Q29sb3I7XG4gIGZvbnQtc2l6ZTogMjBweDtcbiAgbWFyZ2luOiAwcHg7XG4gIHBhZGRpbmctdG9wOiAxcmVtO1xuICBmb250LXdlaWdodDogNjAwO1xufVxuXG4uZXhwZXJpZW5jZS10ZXh0LWRlc2Mge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbi5leHBlcmllbmNlLXRleHQtZGV0YWlscyB7XG4gIHBhZGRpbmc6IDEuNXJlbTtcbiAgbWFyZ2luLXRvcDogMnJlbTtcbn1cblxuLyogTWVkaWEgUXVlcnkgKi9cblxuQG1lZGlhIChtYXgtd2lkdGg6IDEzODBweCkge1xuICAuZXhwZXJpZW5jZS10ZXh0LXJvbGUge1xuICAgIHBhZGRpbmctdG9wOiAwLjVyZW07XG4gICAgZm9udC1zaXplOiAyMnB4O1xuICB9XG4gIC5leHBlcmllbmNlLXRleHQtY29tcGFueSB7XG4gICAgZm9udC1zaXplOiAyMnB4O1xuICB9XG4gIC5leHBlcmllbmNlLXRleHQtZGF0ZSB7XG4gICAgZm9udC1zaXplOiAxOHB4O1xuICB9XG4gIC5leHBlcmllbmNlLXJvdW5kZWRpbWcge1xuICAgIHdpZHRoOiA2LjVyZW07XG4gICAgaGVpZ2h0OiA2LjVyZW07XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5leHBlcmllbmNlLXRleHQtcm9sZSB7XG4gICAgZm9udC1zaXplOiAyMnB4O1xuICB9XG4gIC5leHBlcmllbmNlLXRleHQtY29tcGFueSB7XG4gICAgZm9udC1zaXplOiAyMnB4O1xuICB9XG4gIC5leHBlcmllbmNlLXRleHQtZGF0ZSB7XG4gICAgZm9udC1zaXplOiAxOHB4O1xuICB9XG4gIC5leHBlcmllbmNlLXRleHQtZGVzYyB7XG4gICAgZm9udC1zaXplOiAxNnB4O1xuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
